export default __webpack_public_path__ + "static/media/register1.71c9b17b.jpg";